import { apiSlice } from "../Api/apiSlice";

export const videoApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "/videos",
    }),
    getOneVideo: builder.query({
      query: (id) => `/videos/${id}`,
    }),
    addVideos: builder.mutation({
      query: (formData) => ({
        url: "/videos",
        method: "POST",
        body: formData,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data: UpdatedVideo } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              draft.push(UpdatedVideo);
            })
          );
        } catch (err) {}
      },
    }),
  }),
});

export const { useGetOneVideoQuery, useGetVideosQuery, useAddVideosMutation } =
  videoApi;
